"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canOmitBankDetails = exports.requiresHexaBankDetails = exports.PERCEPTION_RIB_FILES = exports.isPrivateEquityOnly = void 0;
const EProductType_1 = require("../enums/ProductSheet/EProductType");
const ESubFilesTypes_1 = require("../enums/Subscription/File/ESubFilesTypes");
function isPrivateEquityOnly(productsSubscribed) {
    return !!productsSubscribed?.length && productsSubscribed.every((product) => product.productSheet?.product?.productType === EProductType_1.EProductType.private_equity);
}
exports.isPrivateEquityOnly = isPrivateEquityOnly;
exports.PERCEPTION_RIB_FILES = [ESubFilesTypes_1.ESubFilesTypes.RIB, ESubFilesTypes_1.ESubFilesTypes.RIB_CORPORATION];
function requiresHexaBankDetails(products) {
    return !!products?.some((item) => item.productSheet?.product?.referenceName === "hexa_scale_fund");
}
exports.requiresHexaBankDetails = requiresHexaBankDetails;
function canOmitBankDetails(products) {
    return isPrivateEquityOnly(products) && !requiresHexaBankDetails(products);
}
exports.canOmitBankDetails = canOmitBankDetails;
